import { components, seoBoxContainerId, subFeatureContainerId } from '../../universal/common/constants';
import SeoBoxMain from './SeoBoxMain';
import SubFeatureMain from './SubFeatureMain';

class AppManager {
    components = {
        [components.SEO_BOX]: null,
        [components.SUB_FEATURE]: null,
    };

    constructor(params) {
        this.components.seoBox = new SeoBoxMain(document.getElementById(seoBoxContainerId), params);
        this.components.subFeature = new SubFeatureMain(document.getElementById(subFeatureContainerId), params);
    }

    show = (component, data) => {
        this.components[component].mount(data);
    };

    hide = (component) => {
        this.components[component].unmount();
    }
}

export default AppManager;
